import {
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  NgbModal,
  ModalDismissReasons
} from '@ng-bootstrap/ng-bootstrap';

import {
  CategoryDTO,
  CategoryImageDTO
} from '../../../../shared/models/model';

import {
  CategoryService
} from '../../../../shared/service/category.service';

import {
  NotificationService
} from 'src/app/shared/service/notification.service';

import {
  ToastrService
} from 'ngx-toastr';

import {
  LocalDataSource
} from 'ng2-smart-table';

import Swal from 'sweetalert2';


/*
 * =========================================================
 * CUSTOM COMPONENT FOR IMAGE UPLOAD INSIDE SMART TABLE
 * =========================================================
 */

@Component({
  selector: 'app-category-image-upload',
  template: `
    <div style="display:flex; align-items:center; gap:8px;">

      <input
        #fileInput
        type="file"
        accept="image/*"
        style="display:none"
        (change)="onFileSelected($event)"
      />

      <button
        type="button"
        class="btn btn-primary btn-sm"
        (click)="fileInput.click()"
      >
        <i class="fa fa-upload"></i>
        Change image
      </button>

    </div>
  `
})
export class CategoryImageUploadComponent {

  @Input()
  value: any;

  @Input()
  rowData: any;


  constructor(
    private categoryService: CategoryService
  ) {
  }


  onFileSelected(
    event: any
  ): void {
    debugger

    const file: File =
      event.target.files[0];


    if (!file) {
      return;
    }
     
    const categoryId =
      this.rowData.idcategory;


    console.log(
      'CATEGORY ID:',
      categoryId
    );


    console.log(
      'FILE:',
      file
    );


    const reader =
      new FileReader();


    reader.onload =
      () => {
        const dataUrl =
          reader.result as string;


        const base64 =
          dataUrl.split(',')[1];


        // const category =
        //   new CategoryDTO();


        // category.idcategory =
        //   categoryId;


       const categoryimages =
          new CategoryImageDTO();


          categoryimages.name =
          file.name;

          categoryimages.blobValue =
          base64;
          categoryimages.categoryId=categoryId;
           


        console.log(
          'CATEGORY IMAGE OBJECT:',
          categoryimages
        );


        /*
         * IMPORTANT:
         *
         * On réutilise updateCategory()
         * puisque cette méthode existe déjà chez toi.
         *
         * Si ton backend a un endpoint spécial image,
         * on pourra le remplacer plus tard.
         */
        const result: any =
          this.categoryService
            .updateimgCategory(
              categoryimages
            );


        /*
         * Si updateCategory retourne un Observable
         */
        if (
          result &&
          typeof result.subscribe === 'function'
        ) {

          result.subscribe({

            next: response => {

              console.log(
                'IMAGE UPDATED:',
                response
              );


              Swal.fire(
                'Success',
                'Category image updated.',
                'success'
              );

            },


            error: error => {

              console.error(
                'IMAGE UPDATE ERROR:',
                error
              );


              Swal.fire(
                'Error',
                'Unable to update category image.',
                'error'
              );

            }

          });

        } else {

          /*
           * Ton service actuel semble peut-être
           * faire le subscribe lui-même.
           */
          Swal.fire(
            'Upload sent',
            'Image update request sent.',
            'success'
          );

        }

      };


    reader.onerror =
      error => {

        console.error(
          'FileReader error:',
          error
        );


        Swal.fire(
          'Error',
          'Unable to read image.',
          'error'
        );

      };


    reader.readAsDataURL(
      file
    );

  }

}


/*
 * =========================================================
 * CATEGORY COMPONENT
 * =========================================================
 */

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  public closeResult: string;


  public categoriesList: CategoryDTO[] =
    [];


  public Category: CategoryDTO =
    new CategoryDTO();


  public Source: LocalDataSource;


  selectedImage: any;


  public BlobValue: string;


  public FileName: string;


  public base64Image!: string;


  constructor(
    private modalService: NgbModal,
    private backService: CategoryService,
    private notifcationService: NotificationService,
    private toastr: ToastrService
  ) {

    this.Source =
      new LocalDataSource();

  }


  /*
   * =====================================================
   * INIT
   * =====================================================
   */

  ngOnInit() {

    this.loadGrid();

  }


  /*
   * =====================================================
   * LOAD GRID
   * =====================================================
   */

  loadGrid() {

    this.backService
      .getAllCategories()
      .subscribe(
        data => {

          this.categoriesList =
            data;


          console.log(
            'data',
            this.categoriesList
          );


          this.Source =
            new LocalDataSource(
              this.categoriesList
            );


          this.Source.refresh();

        }
      );

  }


  /*
   * =====================================================
   * OPEN MODAL
   * =====================================================
   */

  open(content) {

    this.modalService
      .open(
        content,
        {
          ariaLabelledBy:
            'modal-basic-title'
        }
      )
      .result
      .then(

        result => {

          this.closeResult =
            `Closed with: ${result}`;

        },

        reason => {

          this.closeResult =
            `Dismissed ${this.getDismissReason(reason)}`;

        }

      );

  }


  /*
   * =====================================================
   * UPDATE CATEGORY
   * =====================================================
   */

  updateRecord(event) {

    debugger

    console.log(
      'new data',
      event.newData
    );


    this.Category =
      new CategoryDTO();


    this.Category.description =
      event.newData.description;


    this.Category.es_description =
      event.newData.eS_Description;


    this.Category.fr_description =
      event.newData.fR_Description;


    this.Category.idcategory =
      event.data.idcategory;


    this.backService
      .updateCategory(
        this.Category
      );


    event.confirm.resolve(
      event.newData
    );

  }


  /*
   * =====================================================
   * DELETE CATEGORY
   * =====================================================
   */

  deleteRecord(event) {

    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
  
      if (result.isConfirmed) {
  
        console.log('category to delete:', event.data);
  
        this.Category = new CategoryDTO();
  
        this.Category.idcategory =
          event.data.idcategory;
  
        this.backService.deleteCategory(
          event.data.idcategory
        );
  
        event.confirm.resolve(
          event.newData
        );
  
        Swal.fire(
          'Deleted!',
          'Your category has been deleted.',
          'success'
        );
      }
  
    });
  
  }


  /*
   * =====================================================
   * MODAL DISMISS
   * =====================================================
   */

  private getDismissReason(
    reason: any
  ): string {

    if (
      reason ===
      ModalDismissReasons.ESC
    ) {

      return 'by pressing ESC';

    }

    else if (
      reason ===
      ModalDismissReasons.BACKDROP_CLICK
    ) {

      return 'by clicking on a backdrop';

    }

    else {

      return `with: ${reason}`;

    }

  }


  /*
   * =====================================================
   * SMART TABLE SETTINGS
   * =====================================================
   */

  public settings = {

    mode:
      'inline',


    delete: {

      confirmDelete:
        true

    },


    edit: {

      confirmSave:
        true

    },


    actions: {

      position:
        'right',

      update:
        true

    },


    columns: {

      idcategory: {

        title:
          'Idcategory'

      },


      description: {

        title:
          'Description'

      },


      fR_Description: {

        title:
          'fr_description'

      },


      eS_Description: {

        title:
          'es_description'

      },


      Categoryimage: {

        title:
          'Image',

        type:
          'custom',

        renderComponent:
          CategoryImageUploadComponent,

        filter:
          false,

        sort:
          false

      }

    }

  };


  /*
   * =====================================================
   * IMAGE FOR NEW CATEGORY
   * =====================================================
   */

  onImageSelected(
    event: any
  ) {

    const file: File =
      event.target.files[0];


    if (
      !file
    ) {

      return;

    }


    this.FileName =
      file.name;


    const reader =
      new FileReader();


    reader.onload =
      () => {

        const dataUrl =
          reader.result as string;


        this.base64Image =
          dataUrl.split(',')[1];


        console.log(
          'Base64 OK:',
          this.base64Image
        );

      };


    reader.onerror =
      err => {

        console.error(
          'FileReader error',
          err
        );

      };


    reader.readAsDataURL(
      file
    );

  }


  extractBase64FromDataURL(
    dataURL: string
  ): string {

    return dataURL
      .split(',')[1];

  }


  /*
   * =====================================================
   * ADD CATEGORY
   * =====================================================
   */

  onSubmit(
    contactForm
  ) {

    console.log(
      'submit'
    );


    this.Category =
      new CategoryDTO();


    this.Category.description =
      contactForm.value[
        'Description'
      ];


    this.Category.es_description =
      contactForm.value[
        'ES_Description'
      ];


    this.Category.fr_description =
      contactForm.value[
        'Fr_Description'
      ];


    this.Category.fr_category_title =
      contactForm.value[
        'fr_category_title'
      ];


    this.Category.es_category_title =
      contactForm.value[
        'es_category_title'
      ];


    this.Category.category_title =
      contactForm.value[
        'category_title'
      ];


    this.Category.detail =
      contactForm.value[
        'detail'
      ];


    this.Category.es_detail =
      contactForm.value[
        'es_detail'
      ];


    this.Category.fr_detail =
      contactForm.value[
        'fr_detail'
      ];


    /*
     * IMAGE
     */

    this.Category.categoryimages =
      new CategoryImageDTO();


    this.Category
      .categoryimages
      .blobValue =
      this.base64Image;


    this.Category
      .categoryimages
      .name =
      this.FileName;


    console.log(
      'category',
      this.Category
    );


    this.backService
      .addCategory(
        this.Category
      );


    setTimeout(
      () => {

        this.loadGrid();

      },
      500
    );

  }

}